<template>
    <div class="o-crop">
        <template v-if="alert">
            <MChart :alert-data="alert"/>
            <m-title :title="`Alert ${alert.id}`" />
            <div class="l-row">
                <div class="l-row__column">
                    <template v-if="alert.created_at">
                        <p class="a-label">Utworzono</p>
                        <p class="a-text">{{ $dayjs(alert.created_at).format('DD.MM.YYYY, HH:mm:ss') }}</p>
                    </template>
                    <div class="a-text a-text--bigger">
                        Poziom zagrożenia: <span class="a-text--bold a-text--primary">{{ alert.danger }} </span>
                </div>
                </div>

            </div>

            <div class="l-row" v-if="alert.description && descriptionWithoutTags">
                <div class="l-row__column">
                    <p class="a-label">Zalecenia</p>
                    <p class="a-text" v-html="alert.description"></p>
                </div>
            </div>
            <m-list-card
                v-if="alert.agrofags && alert.agrofags.length > 0"
                title="Agrofagi"
                icon="Agrofags"
                router-single-name="agrofag"
                :list="alert.agrofags"
            />
            <m-list-card
                v-if="alert.crops && alert.crops.length > 0"
                title="Uprawy"
                icon="Crops"
                router-single-name="crop"
                :list="alert.crops"
            />
            <m-list-card
                v-if="county"
                title="Powiat"
                icon="Dashboard"
                :list="[county]"

            />
            <m-gallery
                v-if="alert.images && alert.images.length > 0"
                :images="photos"
            />
            <template v-if="alert.protectors && alert.protectors.length > 0">
                <m-tabs
                    v-if="alertRelated"
                    :items="alertRelated"
                    @input="tab = $event.value"
                    :selected="tab"
                    :center="true"
                />
                <m-list
                    router-single-name="protector"
                    :list="alert.protectors"
                >
                    <template slot="list" slot-scope="props">
                        <div class="m-list__itemPhoto">
                            <a-image
                                v-if="props.item.photos && props.item.photos.length > 0 && !!props.item.photos.find(item => item.is_main === true)"
                                :src="props.item.photos.find(item => item.is_main === true).full_uri"
                                :alt="props.item.name"
                            />
                            <figure
                                v-else
                                class="a-image"
                            ></figure>
                        </div>
                        <p
                            class="m-list__itemTitle m-list__itemTitle--margins m-list__itemTitle--capitalize"
                            :style="authIsAdvisor && props.item.position_group ? { color: props.item.position_group.hex } : false"
                        >
                            {{ props.item.name }}
                        </p>
                        <div class="m-list__itemIcons">
                            <a-icon
                                v-if="props.item.youtube_link"
                                class="m-list__icon"
                                icon="Video"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.notes && props.item.notes.length > 0 ? 'Note' : 'NoteLight'"
                            />
                            <a-icon
                                class="m-list__icon"
                                :icon="props.item.is_favorite ? 'Favorite' : 'FavoriteLight'"
                            />
                        </div>
                    </template>
                </m-list>
            </template>
        </template>
        <a-spinner v-else />
    </div>
</template>

<script>
import MChart from '@/components/MChart'
export default {
    metaInfo() {
        return {
            title: this.metaTitle
        }
    },
    components: { MChart },
    data() {
        return {
            tab: '',
            metaTitle: 'Alert'
        }
    },
    computed: {
        alert() {
            return this.$store.getters.alert
        },
        alertStatus() {
            return this.$store.getters.alertStatus
        },
        alertRelated() {
            if(this.alert.protectors.length > 0) {
                return [{
                    value: 'protectors',
                    label: 'Powiązane środki'
                }]
            } else {
                return null
            }
        },
        descriptionWithoutTags() {
            return this.alert.description.replace(/(<([^>]+)>)/gi, '')
        },
        photos() {
            return this.alert.images.map(item => item.full_path)
        },
        county() {
            return {
                id: this.alert.point.county.ogr_fid,
                name: this.alert.point.county.jpt_nazwa_
            }
        },
        authIsAdvisor() {
            return this.$store.getters.authIsAdvisor
        }
    },
    methods: {
        fetchAlert() {
            if(!isNaN(this.$route.params.id)) {
                this.$store.dispatch('fetchAlert', this.$route.params.id).then(() => {
                    this.metaTitle = `Alert ${this.alert.id}`
                    // init tabs
                    if(this.alert.protectors && this.alert.protectors.length > 0) {
                        this.tab = 'protectors'
                    }
                })
            } else {
                this.$router.push({ name: 'error404' })
            }
        }
    },
    created() {
        this.fetchAlert()
    }
}
</script>